export const getIndexByAttr = function(array, attr, value) {
    for (var i = 0; i < array.length; i += 1) {
        if (array[i] != null && array[i][attr] === value) {
            return i;
        }
    }
    return -1;
}

export const getByAttr = function(array, attr, value) {
    for (var i = 0; i < array.length; i += 1) {
        if (array[i] != null && array[i][attr] === value) {
            return array[i];
        }
    }
    return undefined;
}


function lighten(color) {
    return shadeColor(color, 30);
}

function darken(color) {
    return shadeColor(color, -30);
}

function colorObject(color) {
    return shadeColor(color, 0);
}


function shadeColor(color, percent) {
        let R = 0, G = 0, B = 0;
        if (typeof color == 'string') {
            R = parseInt(color.substring(1, 3), 16);
            G = parseInt(color.substring(3, 5), 16);
            B = parseInt(color.substring(5, 7), 16);
        }
        else if (typeof color == 'object') {
            R = color[0];
            G = color[1];
            B = color[2];

        }
        else {
            const err = `Error creating shadeColor with precent ${percent}. Color is no hex or rgb number array`;
            console.log(err, color);
            return(err)
        }

        R = Number(R * (100 + percent) / 100).toFixed(16);
        G = Number(G * (100 + percent) / 100).toFixed(16);
        B = Number(B * (100 + percent) / 100).toFixed(16);

        R = (R < 255) ? R : 255;
        G = (G < 255) ? G : 255;
        B = (B < 255) ? B : 255;

        var RR = ((R.toString(16).length == 1) ? "0" + R.toString(16) : R.toString(16));
        var GG = ((G.toString(16).length == 1) ? "0" + G.toString(16) : G.toString(16));
        var BB = ((B.toString(16).length == 1) ? "0" + B.toString(16) : B.toString(16));


        return({
            hex: "#" + RR + GG + BB,
            rgb: [R, G, B]
        });
}